<template>
 <div class="wrapper">
    <item-detail :detail="detail" :detailShow="detailShow"></item-detail>
  </div>
</template>
<script>
import itemDetail from "@/components/common/itemDetail.vue";
import { userApi } from "@/api/user.js";
export default {
  data() {
    return {
      detailShow: false,
      detail: {}
    };
  },
  mounted() {
    this.conDetail();
  },
  methods: {
    toPage(url) {
      this.$router.push(url);
    },
    conDetail() {
      userApi.statement().then(res => {
        this.detail = res.data;
      });
    }
  },
  components: {
    itemDetail
  }
};
</script>

<style lang="less" scoped>
@import "./../../common/minix.less";
.wrapper {
  padding: 20 / @rem;
  box-sizing: border-box;
  background: #f2f2f2;
}
</style>




// WEBPACK FOOTER //
// src/components/conUs/statement.vue